import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import ProgressComponent from "../../../components/general/ProgressComponent";
import Layout from "../../../components/layouts/Layout";
import password_eye_icon_circle from "../../../assets/images/icons/password_eye_icon_circle.svg";
import {
    BASE_URL,
    GET_SINGLE_PBS_PLANS_URL,
} from "../../../env";
import {
    getRecords,
    isSuccess,
    catchAsync,
} from "../../../helper/helper";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import UserDetailReview from '../../../components/user-detail/UserDetailReview';
function PbsPlansHistory() {
    const navigate = useNavigate();
    // check if pbs plan id exists or not 
    const localStoragepbsPlan = localStorage.getItem("pbsPlanDetailId");
    let parsedPbsPlan = null;

    if (localStoragepbsPlan === null) {
        navigate("/pbs-plans");
    } else {
        try {
            parsedPbsPlan = JSON.parse(localStoragepbsPlan);
        } catch (error) {
            console.error("Invalid JSON in localStorage", error);
            navigate("/pbs-plans");
        }
    }

    const storedUserDetails = localStorage.getItem("profileUserDetails");
    const userDetails = JSON.parse(storedUserDetails);
    const [userData, setUserData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isPbsPlansHistory, setIsPbsPlansHistory] = useState(false);


    // Getting records from DB
    const processFetchRecords = (method, data) => {
        if (method === "get" && data?.status === isSuccess) {
            const pbsPlanList = data?.data?.pbsHistory
                ?.map((item) => item)
                .sort((a, b) => {
                    const aTime = a.lastModifiedBy?.length
                        ? new Date(a.lastModifiedBy[a.lastModifiedBy.length - 1].modifiedTime)
                        : new Date(0);
                    const bTime = b.lastModifiedBy?.length
                        ? new Date(b.lastModifiedBy[b.lastModifiedBy.length - 1].modifiedTime)
                        : new Date(0);
                    return bTime - aTime;
                });
            setUserData(pbsPlanList);
            setIsLoading(false);
        } else if (method === "delete" && data?.status === isSuccess) {
            setTimeout(() => {
                setIsPbsPlansHistory(false);
            }, 2000);
        }

    };

    const fetchAllRecords = catchAsync(async (req, res) => {
        const response = await getRecords(GET_SINGLE_PBS_PLANS_URL, { pbsId: parsedPbsPlan, });
        processFetchRecords("get", response);
    });

    useEffect(() => {
        if (parsedPbsPlan) {
            fetchAllRecords();
        }
    }, [parsedPbsPlan]);



    const columns = [
        {
            name: "Document Created Date - Time",
            selector: (row) => {
                return (
                    <div>
                        <span>{moment(row?.createdAt).format("DD/MM/YYYY / hh:mm:ss A")}</span>
                    </div>
                );
            },
            width: "22%"
        },
        {
            name: "Entered By",
            selector: (row) => {
                return (
                    <>
                        <span className="usersNameInfo">
                            <span className="userImage">
                                <img src={`${BASE_URL}${row?.staffId?.profile_picture_url}`} alt={row?.staffId?.name} />
                            </span>
                            <span className="userInfo">
                                <span className="nameBlock">{row?.staffId?.name}</span>
                            </span>
                        </span>
                    </>
                );
            },
            wrap: true,
            width: "22%"
        },
        {
            name: "Last Modified Date - Time",
            selector: (row) => {
                const lastModifiedBy = row?.lastModifiedBy ?? [];
                const lastIndex = lastModifiedBy.length - 1;

                return lastIndex >= 0 && lastModifiedBy[lastIndex]?.modifiedUser?.name ? (
                    <div>
                        <span>
                            {moment(lastModifiedBy[lastIndex]?.modifiedTime)
                                .format("DD/MM/YYYY / hh:mm:ss A")}
                        </span>
                    </div>
                ) : (
                    <span>&nbsp;</span>
                );
            },
            width: "22%"
        },
        {
            name: "Last Modified By",
            selector: (row) => {
                const lastModifiedBy = row?.lastModifiedBy ?? [];
                const lastIndex = lastModifiedBy.length - 1;

                return lastIndex >= 0 && lastModifiedBy[lastIndex]?.modifiedUser?.name ? (
                    <span className="usersNameInfo">
                        <span className="userImage">
                            <img
                                src={`${BASE_URL}${lastModifiedBy[lastIndex]?.modifiedUser?.profile_picture_url}`}
                                alt={lastModifiedBy[lastIndex]?.modifiedUser?.name}
                            />
                        </span>
                        <span className="userInfo">
                            <span className="nameBlock">
                                {lastModifiedBy[lastIndex]?.modifiedUser?.name}
                            </span>
                        </span>
                    </span>
                ) : (
                    <span>&nbsp;</span>
                );
            },
            width: "22%"
        },
        {
            name: "Action",
            selector: (row) => {
                return (
                    <div className="actionColumns individualReviewsActions">

                        <span className="edit" onClick={() => handleViewHistoryPBSPlans(row, "/view-history-pbsplans")}>
                            <img src={password_eye_icon_circle} alt="View" title="View" />
                        </span>

                    </div>
                );
            },
            center: true,
            wrap: true,
            width: "12%"
        },
    ];




    useEffect(() => {
        setTimeout(() => {
            setIsPbsPlansHistory(false);
        }, 2000);
    }, [isPbsPlansHistory])

    const handleViewHistoryPBSPlans = (item, url) => {
        localStorage.setItem(
            "pbsPlanHistoryItemData",
            JSON.stringify(item)
        );
        navigate(url);
    };

    return (
        <>
            <Layout pageTitleText="PBS Plans - History">
                <UserDetailReview
                    getUserRecord={userDetails}
                    avatarActionButtons={false}
                    viewNotes={false}
                    profileDetail={false}
                    horizontalDetail={true}
                    launchVideoButtons={true}
                />
                <div className="rowClickUnset mt-3">
                    <div className="mainContent">
                        <div className="dataTableWrapper carePlanDataTableWrapper">
                            <DataTable
                                className="maxWidthTable minWidthTable"
                                columns={columns}
                                data={userData}
                                pagination
                                paginationRowsPerPageOptions={[10, 25, 50, 100]}
                                paginationPerPage={10}
                                fixedHeader
                                fixedHeaderScrollHeight="520px"
                                highlightOnHover
                                progressPending={isLoading}
                                progressComponent={<ProgressComponent />}
                                actions={
                                    <>

                                        <span
                                            className="btn btn-sm btn-primary"
                                            onClick={() => navigate("/pbs-plans")}
                                        >
                                            Back to PBS Plans
                                        </span>
                                    </>
                                }
                            />
                        </div>
                    </div>
                </div>
            </Layout>

        </>
    );
}

export default PbsPlansHistory;